import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'core-js/es6/string';
import 'core-js/es6/symbol';
import 'core-js/fn/symbol/iterator';

import 'normalize.css';
import 'leaflet/dist/leaflet.css';
import 'react-tabs/style/react-tabs.css';
import 'react-dropdown/style.css';
import './index.css';
// import './assets/styles/themes/bus-eireann.css';
// import './assets/styles/themes/dublin-express.css';
// import './assets/styles/themes/megabus.css'; // FIX: temp
// import './assets/styles/themes/nxbus.css'; // FIX: temp
import App from './App';

import store from './store/configureStore';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js